// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getAllFromController } from "@lib/api"

export const getData = createAsyncThunk("appVisits/getData", async (params) => {
  // prettier-ignore
  let eventReasonIdParam = params.eventReasonId ? `&filters[eventReasonId]=${params.eventReasonId}` : ""
  if (Array.isArray(params.eventReasonId)) {
    eventReasonIdParam = params.eventReasonId.map((id) => `&filters[eventReasonId]=${id}`).join("")
  }
  const offsetParam = (params.page - 1) * params.perPage
  const showroomIdParam = params.showroomId ? `&filters[showroomId]=${params.showroomId}` : ""
  const queryStringSearchParam = params.q ? `&search=${params.q}` : ""

  const data = await getAllFromController(
    `Events?offset=${offsetParam}&sort[${params.sortColumn}]=${params.sort}&limit=${params.perPage}${eventReasonIdParam}${showroomIdParam}${queryStringSearchParam}`,
    "visits"
  )
  return {
    params,
    data: data.data,
    allData: data.data,
    totalPages: data.total
  }
})

export const appVisitsSlice = createSlice({
  name: "appVisits",
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    formData: null
  },
  reducers: {
    setFormData: (state, action) => {
      state.formData = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
    })
  }
})

export const { setFormData } = appVisitsSlice.actions
export default appVisitsSlice.reducer
